import invariant from 'invariant';
import ComboboxItems from "../ComboboxItems";
import ComboboxSelections from "../ComboboxSelections";
import FilteredComboboxItems from "../FilteredComboboxItems";

function checkInvariantViolations(_ref) {
  var _ref$childrenTypes = _ref.childrenTypes,
      childrenTypes = _ref$childrenTypes === void 0 ? [] : _ref$childrenTypes,
      hasOnChange = _ref.hasOnChange,
      hasOptions = _ref.hasOptions;

  if (childrenTypes.length > 0) {
    invariant(!hasOnChange && !hasOptions, 'If children are provided, neither onChange or options should be provided.');
    invariant(childrenTypes.length === 2, 'Exactly 2 children should be supplied.');
    invariant(childrenTypes[0] === ComboboxSelections, 'First child must be <ComboboxSelections>');
    invariant(childrenTypes[1] === ComboboxItems || childrenTypes[1] === FilteredComboboxItems, 'Second child must be either <ComboboxItems> or <FilteredComboboxItems>');
  } else {
    invariant(hasOptions && hasOnChange, 'If no children are supplied, both options and onChange must be provided');
  }
}

export default checkInvariantViolations;